module.exports = __webpack_public_path__ + "static/media/verdeElephant.4ed54f76.jpg";